import React from 'react'
import FirstPage from './first';
import AboutPage from '../company/about';
import HeroSectionPage from './herosection';

function homepage() {
  return (
    <div>
    
        <FirstPage/>
      
        <HeroSectionPage/>
        <AboutPage/>

      
    </div>
  )
}

export default homepage;


